/*SYSTEM IMPORTS*/
    import React, { Component } from 'react'

/*VIEWS*/
    import Menu from 'components/Menu'

/*HELPERS*/
    import { ConnectReduxWith } from 'helpers/Redux/connectRedux'

/*CORE*/
    import AppCore from 'cores/AppCore'

@ConnectReduxWith( 'settings' )
class MobileMenu extends Component {
    handleCloseMobileMenu = () => {
        AppCore.ui.closeMobileMenu()
    }

    render() {
        const { settings = false } = this.props

        const { system_settings = {} } = settings

        const { header = {} } = system_settings

        const { menu = [] } = header

        return (
            <div key={ 'mobile-menu' } className="mobile-menu">
                <Menu list={ menu } onItemClick={ this.handleCloseMobileMenu } />
            </div>
        )
    }
}

export default MobileMenu